define([
  'jquery',
  'underscore',
  'marionette',
  'behaviors/form_errors_behavior',
  'lottie/build/player/lottie.min.js', 
  'backbone.syphon',
], function ($, _, Marionette, FormErrorsBehavior, lottie) {
  return Marionette.View.extend({
    el: '#content_layout',

    behaviors: {
      formErrors: {
        behaviorClass: FormErrorsBehavior,
      },
    },

    ui: {
      machine: '.inner-slot-machine',
      button: '.spin',
      sellButton: '.sell',

      /* Modal */
      modalAjax: "#ajax_response_modal",
      modalDesc: "#ajax_response_modal_desc",
      closeButton: '#ajax_response_modal .close-button',

      modalAjax2: "#ajax_response_modal_2",
      closeButton2: '#ajax_response_modal_2 .close-button',
      confirmReceiveButton: "#confirm_receive_button",

      /* Dropdown */
      newSelectBox: '.new-select-box',
      newSelectBoxClick: '.dropdown-wrapper li',
      selectedItem: '.new-select-box .selected',

      stockReadMoreButton: '#stock_read_more_button',

      /* Toast */
      toast: '#toast_success',
      toastText: '#toast_text_success',
    },

    events: {
      'click @ui.button': 'handleButtonClick',

      /* Modal */
      'click @ui.closeButton': 'closeModal',
      'click @ui.confirmReceiveButton': 'confirmReceive',

      'click @ui.sellButton': 'openModal2',
      'click @ui.closeButton2': 'closeModal2',
      'click @ui.stockReadMoreButton': 'readMoreStocks',

      /* Dropdown */
      'click @ui.newSelectBox': function (e) {
        this.displaySorterSelectBox(e);
      },
      'click @ui.newSelectBoxClick': function (e) {
        this.changeLabel(e);
      },
    },

    initialize: function () {
      this.bindUIElements();

      this.createReel((i) => {
        const image = document.createElement('img');
        image.setAttribute('class', 'image');
        image.src = `/assets/common/mypage/img/en_US/promotion/stock/new-logo-${i}.png`;

        return image;
      }, 19);

      this.createReel((i) => {
        const number = document.createElement('span');
        number.setAttribute('class', 'number');
        number.innerHTML = (i + 1) / 100;

        return number;
      }, 100);
    },

    createReel: function (createComponent, length) {
      const reel = document.createElement('div');
      reel.setAttribute('class', 'reel');

      Array.from({ length }, (_, i) => {
        const symbol = document.createElement('div');
        symbol.setAttribute('class', 'symbol');
        symbol.appendChild(createComponent(i));
        reel.appendChild(symbol);
      });

      const first = reel.querySelector('.symbol:first-of-type');
      const last = reel.querySelector('.symbol:last-of-type');

      reel.insertBefore(last.cloneNode(true), reel.firstChild);
      reel.appendChild(first.cloneNode(true));

      this.ui.machine.append(reel);
    },

    anim: async function (target, index) {
      const reel = document.querySelectorAll('.reel')[index - 1];

      const duration = reel.scrollHeight - 216;
      const distance = -(target * 108);
      const delay = 1000 * index * 2 - target * 108;
      const interpolatedDuration = target * 108;

      const keyframes1 = [
        { transform: 'translateY(-100px)' },
        { transform: `translateY(${-reel.scrollHeight + 108}px)` },
      ];
      const options1 = {
        duration: duration,
        easing: 'linear',
        fill: 'forwards',
        iterations: 3,
      };

      const keyframes2 = [
        { transform: 'translateY(-100px)' },
        { transform: `translateY(${distance - 50}px)` },
      ];
      const options2 = {
        delay: delay,
        duration: interpolatedDuration,
        easing: 'linear',
        fill: 'forwards',
        iterations: 1,
      };

      const keyframes3 = [
        { transform: `translateY(${distance - 50}px)` },
        { transform: `translateY(${distance + 50}px)` },
        { transform: `translateY(${distance}px)` },
      ];
      const options3 = {
        duration: 300,
        easing: 'ease-out',
        fill: 'forwards',
        iterations: 1,
      };

      reel.animate(keyframes1, options1);
      await reel.animate(keyframes2, options2).finished;
      reel.getAnimations().map((animation) => animation.cancel());
      await reel.animate(keyframes3, options3).finished;
      reel.getAnimations().map((animation) => animation.finish());

      // slot이 끝난부분이여서 여기에 주식지급 팝업을 띄우고, Refresh
      // ajax_response_modal show up
      if (index === 2) {
        this.ui.modalAjax.modal({ show: true, backdrop: 'static', keyboard: false });

        const l = lottie.loadAnimation({
          container: document.querySelector('.animation'),
          renderer: 'svg',
          loop: false,
          autoplay: false,
          path: '/assets/common/mypage/img/en_US/promotion/stock/animation.json'
        });

        l.play();
      }
    },

    spin: function (targets) {
      targets.forEach((target, index) => this.anim(target, index + 1)
      );
    },

    handleButtonClick: function () {
      const that = this;
      const anims = [];

      $.ajax("/rest_promotion/stock_promotion_receive", {
        method: "POST",
        beforeSend: function () {
          that.ui.button.prop('disabled', true);

          const reels = document.querySelectorAll('.reel');

          reels.forEach(reel => {
            const keyframes1 = [
              { transform: 'translateY(-100px)' },
              { transform: `translateY(${-reel.scrollHeight + 108}px)` },
            ];
            const options1 = {
              duration: reel.scrollHeight - 216,
              easing: 'linear',
              fill: 'forwards',
              iterations: Infinity,
            };

            const anim = reel.animate(keyframes1, options1);
            anims.push(anim);
          });
        },
        success: function (data) {
          // data = {"stockCd":4,"stock":"Microsoft","quantity":0.05};

          anims.forEach(anim => anim.cancel());

          const { stockCd, stock, quantity } = data.data;
          
          $(that.ui.modalDesc).find('div:first-child').text(`${stock} 주식 ${quantity}주를 받았습니다.`);
          $(that.ui.modalDesc).find('img').attr('src', `/assets/common/mypage/img/en_US/promotion/stock/new-logo-${stockCd - 1}.png`);

          that.spin([stockCd, quantity * 100]);
        },
        error: function (xhr, textStatus, errorThrown) {
          anims.forEach(anim => anim.cancel());

          if (xhr.responseJSON.message) {
            that.ui.toastText.html(xhr.responseJSON.message);
            that.ui.toast.addClass('show');

            setTimeout(() => {
              that.ui.toast.removeClass('show')
            }, 5000);

            return;
          }
        },
      });
    },

    /* Modal */
    closeModal: function () {
      this.ui.modalAjax.modal('hide');
      window.location.reload();
    },

    openModal2: function() {
      this.ui.modalAjax2.modal({ show: true, backdrop: 'static', keyboard: false })
    },
    closeModal2: function () {
      this.ui.modalAjax2.modal('hide');
      window.location.reload();
    },

    /* Dropdown */
    displaySorterSelectBox: function (e) {
      const selectBox = $(e.target).children("ul")

      selectBox.toggle();

      if (selectBox.css("display") === 'none') {
          $('.dropdown-wrapper').hide();
      }
    },

    changeLabel: function (e) {
      const liValue = $(e.target).html();
      const ul = $(e.target).parent();
      const selectBox = ul.parent();
      const divLabel = selectBox.children('div');
      ul.toggle();
      divLabel.html(liValue);
      this.ui.selectedItem.data('value', liValue);
    },

    confirmReceive: function (e) {
      const that = this;
      that.ui.confirmReceiveButton.prop('disabled', true);
      that.ui.confirmReceiveButton.css('background-color', 'grey');
      that.ui.confirmReceiveButton.text('요청중..');

      const settlement_account = this.ui.selectedItem.data('value');

      $.ajax("/rest_promotion/stock_promotion_sell", {
        method: "POST",
        data: {
          'settlement_account': settlement_account,
        },
        success: function (data) {
          that.ui.confirmReceiveButton.css('background-color', 'green');
          that.ui.confirmReceiveButton.text('수령완료!');
        },
        error: function (xhr, textStatus, errorThrown) {
          alert(xhr.responseJSON.message);
        },
      });
    },

    readMoreStocks: function() {
      $(".read-more").show();
      $("#stock_read_more_button").hide();
    }
  });
});
